import { callAPI } from "../../network/networkConnection";

const BASE_URL = process.env.REACT_APP_APIUrl + "admin";

/**
 * Get all cron configurations
 */
const getAllCronConfigs = () => {
  return callAPI(
    `${BASE_URL}/cron-configs`,
    "GET",
    { "Content-Type": "application/json" },
    null
  );
};

/**
 * Get single cron configuration
 */
const getCronConfig = (cronKey) => {
  return callAPI(
    `${BASE_URL}/cron-configs/${cronKey}`,
    "GET",
    { "Content-Type": "application/json" },
    null
  );
};

/**
 * Update cron configuration
 */
const updateCronConfig = (cronKey, data) => {
  return callAPI(
    `${BASE_URL}/cron-configs/${cronKey}`,
    "PUT",
    { "Content-Type": "application/json" },
    JSON.stringify(data)
  );
};

/**
 * Toggle cron enabled/disabled
 */
const toggleCronStatus = (cronKey) => {
  return callAPI(
    `${BASE_URL}/cron-configs/${cronKey}/toggle`,
    "PATCH",
    { "Content-Type": "application/json" },
    null
  );
};

/**
 * Manually trigger a cron job
 */
const triggerCronManually = (cronKey) => {
  return callAPI(
    `${BASE_URL}/cron-configs/${cronKey}/trigger`,
    "POST",
    { "Content-Type": "application/json" },
    null
  );
};

/**
 * Test white background swap for a single SKU
 */
const testWhiteBgSingleSku = (sku) => {
  return callAPI(
    `${BASE_URL}/cron-configs/white-bg/test/${sku}`,
    "POST",
    { "Content-Type": "application/json" },
    null
  );
};

/**
 * Get white background processing stats
 */
const getWhiteBgStats = () => {
  return callAPI(
    `${BASE_URL}/cron-configs/white-bg/stats`,
    "GET",
    { "Content-Type": "application/json" },
    null
  );
};

export const cronConfigService = {
  getAllCronConfigs,
  getCronConfig,
  updateCronConfig,
  toggleCronStatus,
  triggerCronManually,
  testWhiteBgSingleSku,
  getWhiteBgStats,
};
